import { ReactNode } from 'react'
import styled from 'styled-components'

/*
Altglas
PET
Sonderabfall
Grüngut
Karton
Papier
Schuhe und Textilien
Kunststoff
Alu
Weiss- und Stahlblech

*/

export const CollectionButton = ({
  label,
  icon,
  id,
  onClick,
}: {
  label: string
  icon: string
  id: string
  onClick: (id: string) => void
}) => {
  return (
    <CollectionButtonRoot onClick={() => onClick(id)}>
      <Icon width={30 + 'px'} height={30 + 'px'}>
        <path d={icon} />
      </Icon>
      <div>{label}</div>
    </CollectionButtonRoot>
  )
}

const CollectionButtonRoot = styled.button`
  flex: 0 0 calc(50% - 10px);
  height: 70px;
  border: 0;
  background-color: var(--site-background);
  background-color: var(--beige-bright-2);
  /* border:1px solid var(--site-background); */
  font-family: var(--font-sans-serif);
  font-size: 17px;
  letter-spacing: 0.4px;
  text-align: left;
  display: flex;
  align-items: center;
  color: var(--brandblue-main) !important;
  div {
    flex: 1;
  }
  @media screen and (min-width: 712px) {
    &:hover {
      cursor: pointer;
      background-color: var(--yellow-main);
      path {
        fill: var(--brandblue-bright-1);
      }
    }
    &:active {
      background-color: var(--beige-bright-2);
    }
  }
  @media screen and (max-width: 711px) {
    flex: 0 0 calc(100% - 0px);
    height: 40px;
    font-size: 14px;
  }
`
const Icon = styled.svg.attrs({ viewBox: '0 0 38.49 38.27' })`
  margin-right: 10px;
  flex: 0 0 40px;
  path {
    fill: var(--brandblue-bright-2);
    fill: var(--beige-main);
  }
`
